import { Outlet } from "react-router-dom";

import { HubLiveConnectionBanner } from "@/components/HubLiveConnectionBanner";
import { HubReconnectBanners } from "@/components/HubReconnectBanners";
import { LaborActiveSessionProvider } from "@/components/LaborActiveSessionProvider";
import { LaborLockdownGate } from "@/components/LaborLockdownGate";
import { LaborPageDepartureWatch } from "@/components/LaborPageDepartureWatch";
import { HubReportIssueHost } from "@/components/HubReportIssueHost";
import { LaborSpaNavigationWatch } from "@/components/LaborSpaNavigationWatch";

/** Renders global reconnect banners, labor session, and page presence on every authenticated hub route. */
export function AuthenticatedHubShell() {
  return (
    <LaborActiveSessionProvider>
      <LaborSpaNavigationWatch />
      <LaborPageDepartureWatch />
      <LaborLockdownGate>
        <HubReportIssueHost>
          <HubLiveConnectionBanner />
          <HubReconnectBanners />
          <Outlet />
        </HubReportIssueHost>
      </LaborLockdownGate>
    </LaborActiveSessionProvider>
  );
}
